import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const statisticsService = {
  getOperationsStats: async (params) => {
    const response = await authInstance
      .get(
        `${url}/cases/statistics/?dateFrom=${params.dateFrom}&dateTo=${params.dateTo}`
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getDailyReports: async (params) => {
    const response = await authInstance
      .get(
        `${url}/operationsDailyReport/list?date=${params.date}&userId=${params.userId}`
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  createDailyReport: async (data) => {
    const response = await authInstance
      .post(`${url}/operationsDailyReport/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
